const routes = [
  {
    path: '/emissor/relatorios_cadastros',
    component: () => import('../views/Listar')
  },
  {
    name: 'formularioRelatoriosCadastro',
    path: '/emissor/relatorios_cadastros/relatorio_clientes',
    component: () => import('../views/Cliente')
  },
  {
    name: 'formularioRelatoriosFornecedor',
    path: '/emissor/relatorios_cadastros/relatorio_fornecedores',
    component: () => import('../views/Fornecedor')
  },
  {
    name: 'formularioRelatoriosTransportadora',
    path: '/emissor/relatorios_cadastros/relatorio_transportadoras',
    component: () => import('../views/Transportadora')
  },
  {
    name: 'formularioRelatoriosProduto',
    path: '/emissor/relatorios_cadastros/relatorio_produtos',
    component: () => import('../views/Produto')
  },
  {
    name: 'formularioRelatoriosServico',
    path: '/emissor/relatorios_cadastros/relatorio_servicos',
    component: () => import('../views/Servico')
  },
  {
    name: 'impressaoRelatorio',
    path: '/emissor/relatorios_cadastros/:tipo/gerar',
    component: () => import('@/shared/components/ui/Relatorio')
  },
]
export default routes
